import React, { Fragment } from 'react';

/*
 * Import Assets
 */
import Balloon from '../../assets/img/mapDecoration/Balloon.png';
import BalloonExplode from '../../assets/img/icons/balloon-explode.gif';
import PopSound from '../../assets/audio/FB5-4_FB6-2_blop-human-pop.wav';

class BalloonEl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      explode: false,
    };
    this.audioRef = React.createRef();
  }

  render() {
    const { explode } = this.state;
    return (
      <Fragment>
        <img
          src={!explode ? Balloon : BalloonExplode}
          className={'balloon ' + (explode ? 'explode' : '')}
          alt={'balloon'}
          onClick={() => {
            const _this = this;
            this.setState({explode: !explode});
            setTimeout(() => {
              if (_this.audioRef && _this.audioRef.current) {
                _this.audioRef.current.play();
              }
            }, 300);
          }}/>

        { explode ? (
          <audio ref={this.audioRef} autoPlay={false}>
            <source src={PopSound} type="audio/wav" />
          </audio>
        ) : null }
      </Fragment>
    )
  }
}

export default BalloonEl;




// WEBPACK FOOTER //
// ./src/components/elements/Balloon.js